import { useContext } from 'react';
import type { FC } from 'react';
import { ClipLoader } from 'react-spinners';
import { LoadingContext } from '../components/appPane';

interface ProgressProps {
  value: boolean;
  subWindow?: boolean;
}

const backgroundStyle: React.CSSProperties = {
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  position: 'absolute',
  backgroundColor: 'rgba(0,0,0,0.5)',
  zIndex: 1000,
};

const wrapperStyle: React.CSSProperties = {
  textAlign: 'center',
  position: 'relative',
  top: '50vh',
};

// サブウィンドウではスタイルが挿入されないためベタ書き
const style =
  '.bLjrOr{animation:cPLlRs 0.75s steps(12, end) infinite;animation-duration:0.75s;}.EuyAg{stroke-width:5px;stroke-linecap:round;}.EuyAg:nth-child(12n + 0){stroke-opacity:0.08;}.EuyAg:nth-child(12n + 1){stroke-opacity:0.17;}.EuyAg:nth-child(12n + 2){stroke-opacity:0.25;}.EuyAg:nth-child(12n + 3){stroke-opacity:0.33;}.EuyAg:nth-child(12n + 4){stroke-opacity:0.42;}.EuyAg:nth-child(12n + 5){stroke-opacity:0.5;}.EuyAg:nth-child(12n + 6){stroke-opacity:0.58;}.EuyAg:nth-child(12n + 7){stroke-opacity:0.66;}.EuyAg:nth-child(12n + 8){stroke-opacity:0.75;}.EuyAg:nth-child(12n + 9){stroke-opacity:0.83;}.EuyAg:nth-child(12n + 11){stroke-opacity:0.92;}@keyframes cPLlRs{to{transform:rotate(360deg);}}';

/**
 * ローディングインジケータを表示する
 * 表示状態はLoadingContextから参照されるため状態を変更したい場合は下記のようにして行う
 * const { setLoading } = useContext(LoadingContext);
 * setLoading(true);
 */
const Progress: FC<ProgressProps> = ({ subWindow }) => {
  const { isLoading } = useContext(LoadingContext);
  return (
    <div className={isLoading ? '' : 'd-none'} style={backgroundStyle}>
      <div style={wrapperStyle}>
        {subWindow ? (
          <style data-styled="active" data-styled-version="6.1.13">
            {style}
          </style>
        ) : (
          ''
        )}
        <ClipLoader size={50} loading={isLoading} />
      </div>
    </div>
  );
};

export default Progress;
